(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[219],{

/***/ 50290:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/teams",
      function () {
        return __webpack_require__(33933);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 33933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ teams; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/app/hocs/PageLayoutV1.tsx + 1 modules
var PageLayoutV1 = __webpack_require__(75019);
// EXTERNAL MODULE: ./src/app/utilities/constants.ts
var constants = __webpack_require__(46613);
// EXTERNAL MODULE: ./src/app/models/Expert.ts
var Expert = __webpack_require__(89736);
// EXTERNAL MODULE: ./src/app/components/experts/SimpleExpertLinkCard.tsx
var SimpleExpertLinkCard = __webpack_require__(18270);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Dropdown.js + 75 modules
var Dropdown = __webpack_require__(29880);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./src/app/components/forms/DropdownComp.tsx




var DropdownComp = function(props) {
    var id = props.id, toggleElem = props.toggleElem, items = props.items, className = props.className, toggleClassName = props.toggleClassName, classes = classnames_default()("standard", className), toggleClasses = classnames_default()("form-control", toggleClassName);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* default */.Z, {
        className: classes,
        onSelect: props.onItemSelected,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default.Toggle */.Z.Toggle, {
                id: id,
                as: "button",
                className: toggleClasses,
                children: toggleElem
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default.Menu */.Z.Menu, {
                children: items.map(function(item) {
                    if (item.isHeader) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default.Header */.Z.Header, {
                            children: item.label
                        }, item.key);
                    } else {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default.Item */.Z.Item, {
                            eventKey: item.key,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: item.label
                            })
                        }, item.key);
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var forms_DropdownComp = (DropdownComp);

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Modal.js + 21 modules
var Modal = __webpack_require__(48313);
// EXTERNAL MODULE: ./node_modules/axios/index.js + 40 modules
var axios = __webpack_require__(50196);
// EXTERNAL MODULE: ./src/app/components/common/Loader.tsx
var Loader = __webpack_require__(41974);
;// CONCATENATED MODULE: ./pages/teams/index.tsx
















var getFilterDropdownItems = function(filters) {
    var filterRoleItems = [
        {
            key: 0,
            label: "All Roles"
        }, 
    ].concat((0,_to_consumable_array/* default */.Z)(filters.roles.map(function(elem) {
        return {
            key: elem,
            label: Expert/* OfficeRole */.$[elem.trim()]
        };
    }))), filterLocationItems = [
        {
            key: 0,
            label: "All Locations"
        }, 
    ].concat((0,_to_consumable_array/* default */.Z)(filters.geolocations.map(function(elem) {
        var ref;
        return {
            key: elem.id,
            label: (ref = elem.name) === null || ref === void 0 ? void 0 : ref.trim()
        };
    }))), filterAoeItems = [
        {
            key: 0,
            label: "All Expertises"
        }, 
    ].concat((0,_to_consumable_array/* default */.Z)(filters.areaOfExpertises.map(function(elem) {
        var ref;
        return {
            key: elem.id,
            label: (ref = elem.name) === null || ref === void 0 ? void 0 : ref.trim()
        };
    }))), filterIssuesTreatedItems = [
        {
            key: 0,
            label: "All Issues Treated"
        }, 
    ].concat((0,_to_consumable_array/* default */.Z)(filters.issuesTreated.map(function(elem) {
        var ref;
        return {
            key: elem.id,
            label: (ref = elem.name) === null || ref === void 0 ? void 0 : ref.trim()
        };
    })));
    return {
        filterRoleItems: filterRoleItems,
        filterLocationItems: filterLocationItems,
        filterAoeItems: filterAoeItems,
        filterIssuesTreatedItems: filterIssuesTreatedItems
    };
};
var TeamsPage = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var ssrExperts = props.experts, ssrFilterResponse = props.filters, ref7 = (0,react.useState)(ssrExperts), experts = ref7[0], setExperts = ref7[1], ref8 = (0,react.useState)(false), loading = ref8[0], setLoading = ref8[1], ref9 = (0,react.useState)(false), showFilterModal = ref9[0], setShowFilterModal = ref9[1];
    var ref10 = getFilterDropdownItems(ssrFilterResponse), filterRoleItems = ref10.filterRoleItems, filterLocationItems = ref10.filterLocationItems, filterAoeItems = ref10.filterAoeItems, filterIssuesTreatedItems = ref10.filterIssuesTreatedItems, ref11 = (0,react.useState)({
        role: {
            selectedItem: null,
            items: filterRoleItems
        },
        locations: {
            selectedItem: null,
            items: filterLocationItems
        },
        areaOfExpertises: {
            selectedItem: null,
            items: filterAoeItems
        },
        issuesTreated: {
            selectedItem: null,
            items: filterIssuesTreatedItems
        }
    }), filterState = ref11[0], setFilterState = ref11[1];
    var doApplyFilter = function(filterState) {
        var selectedRole = filterState.role.selectedItem, selectedLocation = filterState.locations.selectedItem, selectedAoe = filterState.areaOfExpertises.selectedItem, selectedIssues = filterState.issuesTreated.selectedItem, searchParams = lodash_default().omitBy({
            role: (selectedRole === null || selectedRole === void 0 ? void 0 : selectedRole.key) || "",
            locationId: (selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.key) || "",
            aoeServiceId: (selectedAoe === null || selectedAoe === void 0 ? void 0 : selectedAoe.key) || "",
            issuesServiceId: (selectedIssues === null || selectedIssues === void 0 ? void 0 : selectedIssues.key) || ""
        }, // Remove empty values
        function(value) {
            return !value;
        }), requestUri = "/api/search-experts?" + Object.keys(searchParams).map(function(key) {
            return key + "=" + searchParams[key];
        }).join("&");
        setLoading(true);
        return axios/* default.get */.Z.get(requestUri).then(function(res) {
            var expertsResults = res.data.expertsResults;
            setExperts(expertsResults);
            return res;
        }).finally(function() {
            setLoading(false);
        });
    };
    var onRoleFilterSelected = function(key) {
        var selectedItem = filterRoleItems.find(function(elem) {
            return (elem === null || elem === void 0 ? void 0 : elem.key) == key;
        });
        if (selectedItem) {
            var newFilterState = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filterState), {
                role: {
                    selectedItem: selectedItem,
                    items: filterRoleItems
                }
            });
            // Update filter state to show that the filter has been applied
            setFilterState(newFilterState);
            doApplyFilter(newFilterState);
        }
    };
    var onLocationFilterSelected = function(key) {
        var selectedItem = filterLocationItems.find(function(elem) {
            return (elem === null || elem === void 0 ? void 0 : elem.key) == key;
        });
        if (selectedItem) {
            var newFilterState = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filterState), {
                locations: {
                    selectedItem: selectedItem,
                    items: filterLocationItems
                }
            });
            // Update filter state to show that the filter has been applied
            // setFilterState(newFilterState);
            doApplyFilter(newFilterState).then(function(res) {
                var expertsFilters = res.data.expertsFilters;
                // Update filter state to show the latest dropdown items based on the result.
                var newFilterDropdownItems = getFilterDropdownItems(expertsFilters);
                newFilterState.areaOfExpertises.items = newFilterDropdownItems.filterAoeItems;
                newFilterState.issuesTreated.items = newFilterDropdownItems.filterIssuesTreatedItems;
                setFilterState(newFilterState);
            });
        }
    };
    var onAoeFilterSelected = function(key) {
        var selectedItem = filterAoeItems.find(function(elem) {
            return (elem === null || elem === void 0 ? void 0 : elem.key) == key;
        });
        if (selectedItem) {
            var newFilterState = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filterState), {
                areaOfExpertises: {
                    selectedItem: selectedItem,
                    items: filterAoeItems
                }
            });
            // Update filter state to show that the filter has been applied
            // setFilterState(newFilterState);
            doApplyFilter(newFilterState).then(function(res) {
                var expertsFilters = res.data.expertsFilters;
                // Update filter state to show the latest dropdown items based on the result.
                var newFilterDropdownItems = getFilterDropdownItems(expertsFilters);
                newFilterState.locations.items = newFilterDropdownItems.filterLocationItems;
                newFilterState.issuesTreated.items = newFilterDropdownItems.filterIssuesTreatedItems;
                setFilterState(newFilterState);
            });
        }
    };
    var onIssuesFilterSelected = function(key) {
        var selectedItem = filterIssuesTreatedItems.find(function(elem) {
            return (elem === null || elem === void 0 ? void 0 : elem.key) == key;
        });
        if (selectedItem) {
            var newFilterState = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filterState), {
                issuesTreated: {
                    selectedItem: selectedItem,
                    items: filterIssuesTreatedItems
                }
            });
            // Update filter state to show that the filter has been applied
            // setFilterState(newFilterState);
            doApplyFilter(newFilterState).then(function(res) {
                var expertsFilters = res.data.expertsFilters;
                // Update filter state to show the latest dropdown items based on the result.
                var newFilterDropdownItems = getFilterDropdownItems(expertsFilters);
                newFilterState.locations.items = newFilterDropdownItems.filterLocationItems;
                newFilterState.areaOfExpertises.items = newFilterDropdownItems.filterAoeItems;
                setFilterState(newFilterState);
            });
        }
    };
    var doShowFilterModal = function() {
        setShowFilterModal(true);
    };
    var doHideFilterModal = function() {
        setShowFilterModal(false);
    };
    /**
   * Meta contents
   */ var metaTitle = "Team | Heritage Counseling", metaDescription = constants/* META_DESCRIPTION */.KM || "", metaUrl = "".concat(constants/* META_URL */.f1, "/teams"), metaImage = "".concat(constants/* META_URL */.f1, "/logo.png");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageLayoutV1/* default */.Z, {
        title: "Team",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: metaTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "title",
                        content: metaTitle
                    }, "title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: metaDescription
                    }, "description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: metaTitle
                    }, "og:title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: metaDescription
                    }, "og:description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: metaUrl
                    }, "og:url"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: metaImage
                    }, "og:image"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:url",
                        content: metaUrl
                    }, "twitter:url"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: metaTitle
                    }, "twitter:title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: metaDescription
                    }, "twitter:description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: metaImage
                    }, "twitter:image"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        itemProp: "title",
                        content: metaTitle
                    }, "prop:title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        itemProp: "description",
                        content: metaDescription
                    }, "prop:description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: metaUrl
                    }),
                    (experts === null || experts === void 0 ? void 0 : experts.length) > 0 && experts.map(function(expert) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                            type: "application/ld+json",
                            dangerouslySetInnerHTML: {
                                __html: JSON.stringify(expert.schema)
                            }
                        }, expert.slug);
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "teams-page",
                "data-testid": "teams-page",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "filter-container-desktop",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "filter-wrapper",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                htmlFor: "role-filter",
                                                children: "Role"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(forms_DropdownComp, {
                                                id: "role-filter",
                                                className: "filter-dropdown",
                                                onItemSelected: onRoleFilterSelected,
                                                items: filterState.role.items,
                                                toggleElem: ((ref = filterState.role.selectedItem) === null || ref === void 0 ? void 0 : ref.label) || "All Roles"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "filter-wrapper",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                htmlFor: "location-filter",
                                                children: "Location"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(forms_DropdownComp, {
                                                id: "location-filter",
                                                className: "filter-dropdown",
                                                onItemSelected: onLocationFilterSelected,
                                                items: filterState.locations.items,
                                                toggleElem: ((ref1 = filterState.locations.selectedItem) === null || ref1 === void 0 ? void 0 : ref1.label) || "All Locations"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "filter-wrapper",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                htmlFor: "aoe-filter",
                                                children: "Area of Expertise"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(forms_DropdownComp, {
                                                id: "aoe-filter",
                                                className: "filter-dropdown",
                                                onItemSelected: onAoeFilterSelected,
                                                items: filterState.areaOfExpertises.items,
                                                toggleElem: ((ref2 = filterState.areaOfExpertises.selectedItem) === null || ref2 === void 0 ? void 0 : ref2.label) || "All Expertises"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "filter-wrapper",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                htmlFor: "issues-filter",
                                                children: "Issues Treated"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(forms_DropdownComp, {
                                                id: "issues-filter",
                                                className: "filter-dropdown",
                                                onItemSelected: onIssuesFilterSelected,
                                                items: filterState.issuesTreated.items,
                                                toggleElem: ((ref3 = filterState.issuesTreated.selectedItem) === null || ref3 === void 0 ? void 0 : ref3.label) || "All Issues Treated"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "filter-container-mobile",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        type: "button",
                                        title: "Filter",
                                        "aria-label": "Filter",
                                        role: "form",
                                        className: "btn btn-round btn-outline-main",
                                        onClick: doShowFilterModal,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "fa fa-filter"
                                            }),
                                            " Filters"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
                                        className: "standard teams-page-modal-filter",
                                        show: showFilterModal,
                                        onHide: doHideFilterModal,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                                                closeButton: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Title */.Z.Title, {
                                                    children: "Teams Filter"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default.Body */.Z.Body, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "filter-wrapper",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                htmlFor: "location-filter",
                                                                children: "Location"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(forms_DropdownComp, {
                                                                id: "location-filter",
                                                                className: "filter-dropdown",
                                                                onItemSelected: onLocationFilterSelected,
                                                                items: filterState.locations.items,
                                                                toggleElem: ((ref4 = filterState.locations.selectedItem) === null || ref4 === void 0 ? void 0 : ref4.label) || "All Locations"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "filter-wrapper",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                htmlFor: "aoe-filter",
                                                                children: "Area of Expertise"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(forms_DropdownComp, {
                                                                id: "aoe-filter",
                                                                className: "filter-dropdown",
                                                                onItemSelected: onAoeFilterSelected,
                                                                items: filterState.areaOfExpertises.items,
                                                                toggleElem: ((ref5 = filterState.areaOfExpertises.selectedItem) === null || ref5 === void 0 ? void 0 : ref5.label) || "All Expertises"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "filter-wrapper",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                htmlFor: "issues-filter",
                                                                children: "Issues Treated"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(forms_DropdownComp, {
                                                                id: "issues-filter",
                                                                className: "filter-dropdown",
                                                                onItemSelected: onIssuesFilterSelected,
                                                                items: filterState.issuesTreated.items,
                                                                toggleElem: ((ref6 = filterState.issuesTreated.selectedItem) === null || ref6 === void 0 ? void 0 : ref6.label) || "All Issues Treated"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Footer */.Z.Footer, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    type: "button",
                                                    title: "Close Filter",
                                                    "aria-label": "Close Filter",
                                                    role: "form",
                                                    className: "btn btn-round btn-outline-main",
                                                    onClick: doHideFilterModal,
                                                    children: "Close"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {
                        size: 2
                    }) : experts && experts.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "grid-container",
                        children: experts.map(function(expert, idx) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleExpertLinkCard/* default */.Z, {
                                expert: expert
                            }, idx);
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-center",
                        children: "No experts found"
                    })
                ]
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var teams = (TeamsPage);


/***/ }),

/***/ 41974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



var Loader = function(props) {
    var size = props.size, extClassName = props.className, sizeClass = size > 0 ? "fa-".concat(size, "x") : "", classes = classnames__WEBPACK_IMPORTED_MODULE_2___default()("fa fa-spinner fa-pulse", sizeClass, extClassName);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            display: "block",
            textAlign: "center"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
            className: classes,
            "aria-hidden": "true"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Loader);


/***/ }),

/***/ 18270:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);




var SimpleExpertLinkCard = function(props) {
    var ref, ref1, ref2;
    var expert = props.expert, isAmp = props.isAmp, className = props.className, classes = classnames__WEBPACK_IMPORTED_MODULE_3___default()("simple-expert-link-card", className), displayName = [
        expert.firstName || "",
        expert.lastName || ""
    ].filter(Boolean).join(" ");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: "/teams/".concat(expert.slug),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
            className: classes,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "img-container",
                    children: isAmp ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("amp-img", {
                        alt: expert.slug,
                        src: (ref = expert.image) === null || ref === void 0 ? void 0 : ref.src,
                        width: 150,
                        height: 150,
                        layout: "responsive"
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        className: "avatar",
                        src: ((ref1 = expert.image) === null || ref1 === void 0 ? void 0 : ref1.src) || "",
                        loading: "lazy",
                        width: 300,
                        height: 311,
                        alt: expert.slug
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                    className: "display-name",
                    children: [
                        displayName,
                        ((ref2 = expert.credentials) === null || ref2 === void 0 ? void 0 : ref2.length) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            className: "d-none d-md-inline",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: ",\xa0"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "credentials",
                                    children: expert.credentials.join(", ")
                                })
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                    ]
                }),
                expert.position ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "position",
                    children: expert.position
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SimpleExpertLinkCard);


/***/ }),

/***/ 75019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hocs_PageLayoutV1; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./public/static/images/layout/layout-hero-1440.jpg
/* harmony default export */ var layout_hero_1440 = ({"src":"/_next/static/media/layout-hero-1440.020fe420.jpg","height":318,"width":1440,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAACAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAaEAEAAgMBAAAAAAAAAAAAAAABAAIFElFh/8QAFQEBAQAAAAAAAAAAAAAAAAAAAgP/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwCRLWMQhZDbvjERJi//2Q==","blurWidth":8,"blurHeight":2});
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/app/utilities/helpers.ts
var helpers = __webpack_require__(3862);
;// CONCATENATED MODULE: ./src/app/hocs/PageLayoutV1.tsx






var PageLayoutV1 = function(param) {
    var title = param.title, tagline = param.tagline, children = param.children, fluidContainer = param.fluidContainer, noPadding = param.noPadding;
    var isContainerFluid = (0,helpers/* isNullOrUndefined */.le)(fluidContainer) ? false : fluidContainer, containerClasses = classnames_default()("layout-container", {
        container: !isContainerFluid,
        "no-padding": !!noPadding
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "layout-v1",
        "data-testid": "layout-v1",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "preload",
                    as: "image",
                    href: layout_hero_1440.src
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "layout-hero",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "title-container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "title",
                            children: title || "Heritage Consulting"
                        }),
                        tagline ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "tagline",
                            children: tagline
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: containerClasses,
                children: children
            })
        ]
    });
};
/* harmony default export */ var hocs_PageLayoutV1 = (PageLayoutV1);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [662,598,22,561,774,888,179], function() { return __webpack_exec__(50290); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);